var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nothing"},[_c('img',{attrs:{"src":require("@/assets/images/nothing.png"),"alt":""}}),_c('p',[_vm._v("暂无信息")])])}]

export { render, staticRenderFns }